const popoverStyle = {
    popoverContent: `w-[230px] h-auto shadow-lg`, 
    profileHeader: `flex items-start gap-2 pt-3 px-3 h-[38px] bg-primaryHeading`, 
    profileImage: `rounded-full w-[36px] h-[36px] object-cover border border-primaryHeading bg-white`, 
    profileName: `font-[500] text-[16px] text-Suisse text-white uppercase`, 
    popover_tabs: `flex flex-col px-3 py-3`, 
    popover_tab: `flex items-center justify-between border-b last:border-none border-[#E0E0E0] hover:bg-gray-200 transition-all duration-300 w-full cursor-pointer px-2 py-1.5`, 
    popover_tab_disabled: `opacity-50 cursor-default`,
    tab_text: `flex-grow pl-4 text-themeColor font-[500] text-[13px]`, 
    iconImages: `max-w-[20px] max-h-[20px]`
};

export { popoverStyle };
